var map = {
	"./ambassador-bg.webp": 1275,
	"./asset-2.png": 1276,
	"./btn-enter-bg.png": 1277,
	"./btn-enter-white-bg.webp": 1278,
	"./btn-more-bg.webp": 1279,
	"./casino-hover.webp": 1280,
	"./casino.webp": 1281,
	"./convenient.webp": 1282,
	"./es-bg.webp": 1283,
	"./event-sec-bg.webp": 1284,
	"./event-sport-bg.webp": 1285,
	"./fifa1-bg.jpg": 1286,
	"./fifa2-bg-cn.jpg": 1287,
	"./fifa2-bg.jpg": 1288,
	"./games-hover.webp": 1289,
	"./games.webp": 1290,
	"./gauge.webp": 1291,
	"./lottery-hover.webp": 1292,
	"./lottery.webp": 1293,
	"./master-bg.webp": 1294,
	"./p2p-hover.webp": 1295,
	"./p2p.webp": 1296,
	"./platform.webp": 1297,
	"./product-ctg-bg.webp": 1298,
	"./product-overview-bg.webp": 1299,
	"./professional.webp": 1300,
	"./safety.webp": 1301,
	"./slots-hover.webp": 1302,
	"./slots.webp": 1303,
	"./speed.webp": 1304,
	"./sports-hover.webp": 1305,
	"./sports.webp": 1306,
	"./video-bg.webp": 1307,
	"./wave.webp": 1308,
	"./wwr-bg.webp": 1309,
	"./wwr-img-b.webp": 1310,
	"./wwr-img.webp": 1311,
	"./wwr-subImg1.webp": 1312,
	"./wwr-subImg2.webp": 1313,
	"./wwr-subImg3.webp": 1314,
	"./x33-logo-cny.png": 1315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 464;